<!--
|---------------------------------------------
| Footer Component 
|---------------------------------------------
| @usage Import the component and use, no params
| Main Footer Component
-->


<template>
    <div class='container-fluid text-center'> 
        <div class="row bg-rodape justify-content-center">
            <div class="d-flex align-items-center">
                <p class="m-0">© 2021 - Governo do Estado do Ceará - Todos os direitos reservados</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style scoped>
.container-fluid{
    height: 5rem;
    position: absolute;
	bottom: 0;
	left: 0;
}

.row{
    height: 100%;
}

.bg-rodape{
    background-color: #FEB979;
    height: auto;
    min-height: 100%;
}

.logos-footer img {
    margin: 0.8rem;
    max-height: 4rem;
    transition: all .3s ease-in-out; 
 }

 .move-icon {
    height: 3.5rem;
    width: 5rem;
 }

 .logos-footer img:hover {
    transform: scale(1.06); 
 }

 .img-fluid {
     cursor: pointer;
 }

 @media only screen and (max-width:576px) {
     .footer-left{
         margin-top: 5rem;
     }

    .footer-right{
         margin-top: 0.65rem;
     }

     h3{
	    margin-top: 2rem;
     }

     #lepes-logo{
         margin: 0.5rem 0rem;
     }

     #footer{
         grid-template-columns: 1fr;
     }
    
     #footer h1 {
	    font-weight: 100;
     }

}

 p{
     text-align: center;
     color: #fff;
     margin-top: 2.2%;
 }

</style>
